/* ============
 * CourseTransformer
 * ============
 *
 * The transformer for the Course.
 */
import store from '@plugins/vuex'
import Transformer from '@transformers/Transformer'

export default class CourseTransformer extends Transformer {
  /**
   * Method used to transform a fetched Course.
   *
   * @param data The fetched Course.
   *
   * @returns {Object} The transformed Course.
   */

  static COURSE_ID = 0

  static fetch (data) {
    const self = this
    self.COURSE_ID = 'c' + 1
    let result = {
      id: self.COURSE_ID,
      cID: data.id,
      name: data.name,
      areas: [],
      type: data.type
    }
    if (data.hasOwnProperty('description')) {
      result.description = data.description
    }

    let areas = []
    if (data.hasOwnProperty('areas')) {
      // data.areas.forEach((item, index) => {
      data.areas.forEach((item) => {
        areas.push(item)
      })
    }

    areas.forEach((item, index) => {
      let area = self.parseItem(item, index, result.id)
      result.areas.push(area)
    })

    return result
  }

  static uniqueID () {
    function chr4 () {
      return Math.random().toString(16).slice(-4)
    }
    return chr4() + chr4() +
      '-' + chr4() +
      '-' + chr4() +
      '-' + chr4() +
      '-' + chr4() + chr4() + chr4()
  }

  static parseItem (data, index, parentId = null) {
    const self = this
    let _modules, _moduleGroups
    let result = {
      id: parentId ? parentId + '-g' + index : self.COURSE_ID + '-g' + index,
      required: [],
      name: '',
      description: '',
        collapse: 0,
      free: 0
    }
      if (data.hasOwnProperty('collapse') && data.collapse == 1) {

          result.collapse = data.collapse
      }

    if (data.hasOwnProperty('name')) {
      result.name = data.name
    }

    if (data.hasOwnProperty('text')) {
      result.description = data.text
    }

    if (data.hasOwnProperty('free')) {
      result.free = parseInt(data.free)
    }

    result.modules = []
    let moduleIndex = 0
    let moduleKeys = []

    result.type = 'area'
    if (data.hasOwnProperty('type')) {
      result.type = data.type
    }

    if (data.hasOwnProperty('modulegroups')) {
      _moduleGroups = Array.isArray(data.modulegroups) ? data.modulegroups : [data.modulegroups]
      // _moduleGroups.forEach((moduleGroup, mIndex) => {
      _moduleGroups.forEach((moduleGroup) => {
        let group = store.getters.getModuleGroupById(moduleGroup)
        if (group) {
          group.modules.forEach((item) => {
            result.modules.push({
              id: result.id + '-m' + moduleIndex,
              key: item,
              label: item,
              hidden: false
            })
            moduleKeys.push(item)
            moduleIndex++
          })
        }
      })
    }

    if (data.hasOwnProperty('modules')) {
      _modules = Array.isArray(data.modules) ? data.modules : [data.modules]
      // _modules.forEach((module, mIndex) => {
      _modules.forEach((module) => {
        result.modules.push({
          id: result.id + '-m' + moduleIndex,
          key: module,
          label: module,
          hidden: false
        })
        moduleKeys.push(module)
        moduleIndex++
      })
    }

    if (data.hasOwnProperty('min')) {
      result.min = parseInt(data.min)
    }

    if (data.hasOwnProperty('max')) {
      result.max = parseInt(data.max)
      if (result.hasOwnProperty('modules') && moduleKeys.length <= result.max) {
        result.required = moduleKeys
      }
    }

    if (data.hasOwnProperty('required')) {
      let required = Array.isArray(data.required) ? data.required : [data.required]
      // required.forEach((item, index) => {
      required.forEach((item) => {
        if (result.required.indexOf(item) < 0) {
          result.required.push(item)
        }
      })
    }

    if (data.hasOwnProperty('noprint')) {
      result.noprint = parseInt(data.noprint)
    }

    // if (data.hasOwnProperty('description')) {
    //   result.description = data.description
    // }

    let areas = []
    result.areas = []
    if (data.hasOwnProperty('areas')) {
      let gruppe = data.areas
      if (!Array.isArray(data.areas)) {
        gruppe = [data.areas]
      }

      // gruppe.forEach((item, index) => {
      gruppe.forEach((item) => {
        areas.push(item)
      })
    }

    // if (data.hasOwnProperty('free'))
    if (result.free > 0) {
      let freeArea = {
        type: 'input',
        modules: []
      }

        // let programItemsSelected = this.$store.getters['programItemsSelected']
        let programItemsSelected = store.getters['programItemsSelected']
      let programItems = []
      for (let i = 0; i < data.free; i++) {
        if (data.hasOwnProperty('programItems')) {
            programItemsSelected[result.id + '-g' + moduleIndex] = data.programItems

            store.getters['programItems'][result.id] = data.programItems
        }
        let moduleId = result.id + '-m' + moduleIndex
        result.modules.push({
          id: moduleId,
          hidden: true
        })
        moduleKeys.push(module)
        moduleIndex++
        freeArea.modules.push(moduleId)
      }

      store.commit('SET_PROGRAMITEMS', programItems)

      areas.push(freeArea)
    }

    areas.forEach((item, index) => {
      let group = self.parseItem(item, index, result.id)
      result.areas.push(group)
    })

    return result
  }
}
